import * as v from 'valibot';

import type { CCTrialProgram } from '#entities/types';

import { ENOPTrialProgramName } from '../enums';

import { ENOPOrganTypeSchema } from './organ.schema';

export const ETrialProgramNameSchema = v.enum(
  ENOPTrialProgramName,
  'ETrialProgramNameSchema',
);

/** Trial program schema */
export const trialProgramSchema: v.GenericSchema<CCTrialProgram> = v.object({
  /** Unique identifier */
  id: v.string('TrialProgramSchema.id'),
  /** Trial program name */
  name: ETrialProgramNameSchema,
  /** Organ type */
  organ: ENOPOrganTypeSchema,
});
